module.exports = __webpack_public_path__ + "static/media/added.a726e473.svg";